// extracted by mini-css-extract-plugin
module.exports = {"settingContainer":"U0TpQ2bdxDHVrZk0AiLcN"};